import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { IPaginatedFilters } from 'src/app/shared/architecture/envelopes';
import { ProductModelService } from 'src/app/shared/services/core/product-model.service';
import { ChangeDetectorRef } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
  selector: 'app-modelo-produtos',
  imports: [TegelModule, CommonModule, NgxPaginationModule],
  templateUrl: './modelo-produtos.component.html',
  styleUrl: './modelo-produtos.component.scss'
})
export class ModeloProdutosComponent implements OnInit{
  originalProductModels: any[] = [];
  productmodels: any[];
  page = 1;
  pageSize = 10;
  searchText = '';
  private filtros:IPaginatedFilters = { paginationValue: '1', paginationSize: '10', columnKey: '', sortingDirection: '', query: ''};
  order = "produto"

  constructor(private productModelService: ProductModelService, private cdr: ChangeDetectorRef) {
    this.productmodels = [];
  }

  ngOnInit() {
    this.getAllProductModels();
  }

  getAllProductModels() {
    this.productModelService.get().subscribe((result) => {
      if (result) {
        this.originalProductModels = result;
        this.productmodels = result;
        this.cdr.detectChanges();
      }
    });
  }

  onFilterEvent(event: any) {
    const rawValue = event?.detail?.query ?? event?.target?.query ?? '';
    const value = String(rawValue).trim().toLowerCase();

    
    if (!value) {
      this.productmodels = [...this.originalProductModels];
      this.page = 1;
      return;
    }

    this.productmodels = this.originalProductModels.filter(f => {
      const codigo = String(f.produto ?? '').toLowerCase();
      const descricao = String(f.descricao ?? '').toLowerCase();

      return codigo.includes(value) || descricao.includes(value);
    });

    this.page = 1;
  }

  onSortEvent(event: any) {
  const column = event.detail.columnKey;
  const direction = event.detail.sortingDirection; 

  if (!column || direction === 'none') {
    return; 
  }

  
  this.productmodels.sort((a: any, b: any) => {
    const dir = direction === 'asc' ? 1 : -1;

    if (a[column] > b[column]) return 1 * dir;
    if (a[column] < b[column]) return -1 * dir;
    return 0;
  });
}

}
